import FileMaintainanceOverview from "components/FileMaintainance/FileMaintainanceOverview";
import AddNewStockCategory from "components/FileMaintainance/StockCategory/AddStockCategory";
import EditStockCategory from "components/FileMaintainance/StockCategory/EditStockCategory";
import StockCategory from "components/FileMaintainance/StockCategory/StockCategory";
import AddStockItem from "components/FileMaintainance/StockItems/AddStockItem";
import EditStockItem from "components/FileMaintainance/StockItems/EditStockItem";
import StockItem from "components/FileMaintainance/StockItems/StockItem";
import Supplier from "components/FileMaintainance/Supplier/Supplier";
import AddSupplier from "components/FileMaintainance/Supplier/AddSupplier";
import EditSupplier from "components/FileMaintainance/Supplier/EditSupplier";
import { useRouteMatch, Switch, Route } from "react-router-dom";
import EditCustomer from "components/FileMaintainance/Customer/EditCustomer";
import AddCustomer from "components/FileMaintainance/Customer/AddCustomer";
import Customer from "components/FileMaintainance/Customer/Customer";
import Levy from "components/FileMaintainance/Levy/Levy";
import AddLevy from "components/FileMaintainance/Levy/AddLevy";
import EditLevy from "components/FileMaintainance/Levy/EditLevy";

export default function FileMaintainance() {
  let match = useRouteMatch();
  return (
    <>
      <Switch>
        <Route
          path={`${match.path}/customers/edit/:id`}
          component={EditCustomer}
        />
        <Route path={`${match.path}/customers/add`} component={AddCustomer} />
        <Route exact path={`${match.path}/customers`} component={Customer} />
        <Route path={`${match.path}/levies/edit/:id`} component={EditLevy} />
        <Route exact path={`${match.path}/levies`} component={Levy} />
        <Route path={`${match.path}/levies/add`} component={AddLevy} />
        <Route
          path={`${match.path}/suppliers/edit/:id`}
          component={EditSupplier}
        />
        <Route path={`${match.path}/suppliers/add`} component={AddSupplier} />
        <Route exact path={`${match.path}/suppliers`} component={Supplier} />
        <Route
          path={`${match.path}/stock-categories/edit/:id`}
          component={EditStockCategory}
        />
        <Route
          path={`${match.path}/stock-categories/add`}
          component={AddNewStockCategory}
        />
        <Route
          exact
          path={`${match.path}/stock-categories`}
          component={StockCategory}
        />
        <Route
          path={`${match.path}/stock-items/edit/:id`}
          component={EditStockItem}
        />
        <Route
          path={`${match.path}/stock-items/add`}
          component={AddStockItem}
        />
        <Route exact path={`${match.path}/stock-items`} component={StockItem} />
        <Route exact path={match.path} component={FileMaintainanceOverview} />
      </Switch>
    </>
  );
}
